import moment from "moment";
import React, { useState } from "react";
import { Button, Pagination } from "flowbite-react";
import { FaArrowsLeftRight } from "react-icons/fa6";
import axios from "../../config/axiosInstance";
import { useQuery, useQueryClient } from "react-query";
import { ADMIN, CATEGORIES } from "../../config/apiConfig";
import { TbLockSearch } from "react-icons/tb";
import Drawer from "../Drawer";
import UserQueriesForm from "../forms/UserQueriesForm";
import { IoMdAdd, IoMdSearch } from "react-icons/io";
import { Link } from "react-router-dom";
import { FaRegEdit } from "react-icons/fa";
import UserForm from "../forms/UserForm";
import EmptyTable from "./EmptyTable";
import { Tooltip } from "react-tooltip";
import "./AdminRepresentativesTable.css";

const AdminRepresentativesTable = () => {
  const queryClient = useQueryClient();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const onPageChange = (page) => setCurrentPage(page);
  const [searchName, setSearchName] = useState("");
  const [nameParam, setNameParam] = useState("");
  const [isDrawerPermissionQueries, setIsDrawerPermissionQueries] =
    useState(false);
  const [selectedRepresentative, setSelectedRepresentative] = useState(null);
  const [isDrawerEditRepresentative, setIsDrawerEditRepresentative] =
    useState(false);

  const {
    isLoadingListRepresentatives,
    error: errorListRepresentatives,
    data: listRepresentatives,
  } = useQuery(["listRepresentatives", currentPage, nameParam], async () => {
    const { data } = await axios.get(
      `${ADMIN.GET_REPRESENTATIVES}?page=${currentPage}&search=${nameParam}`,
    );

    setTotalPages(data.data.totalPages || 1);
    setTotalCount(data.data.totalCount || 0);

    return data.data.data;
  });

  const {
    isLoadingCategories,
    error: errorCategories,
    data: categories,
  } = useQuery(["categories", currentPage], async () => {
    const { data } = await axios.get(
      `${CATEGORIES.GET_ALL}?page=${currentPage}`,
    );

    return data.data.data;
  });

  const handleSearchName = (e) => {
    e.preventDefault();
    setNameParam(searchName);
  };

  const handleEditRepresentative = (representative) => {
    setSelectedRepresentative(representative);
    setIsDrawerEditRepresentative((prevState) => !prevState);
  };

  const handleEditPermissionQueries = (representative) => {
    setSelectedRepresentative(representative);
    setIsDrawerPermissionQueries((prevState) => !prevState);
  };

  return (
    <>
      <section className="rep-list-shell">
        <header className="rep-list-header">
          <div>
            <h2 className="rep-list-title">Representantes</h2>
            <p className="rep-list-subtitle">
              Gerencie cadastro, permissoes de consulta e edicao dos
              representantes.
            </p>
          </div>

          <Link
            to="/admin/new-representative"
            className="rep-add-btn"
            aria-label="Adicionar Representante"
          >
            <IoMdAdd className="rep-add-icon" />
            <span className="rep-add-text">Adicionar Representante</span>
          </Link>
        </header>

        <form className="rep-list-search" onSubmit={handleSearchName}>
          <input
            type="text"
            placeholder="Buscar por nome, telefone ou e-mail do representante"
            onChange={(e) => setSearchName(e.target.value)}
            value={searchName}
          />
          <button type="submit" className="rep-search-btn">
            <IoMdSearch />
            Buscar
          </button>
        </form>
      </section>

      {listRepresentatives?.length > 0 || isLoadingListRepresentatives ? (
        <>
          <small
            className="gap-2 items-center mt-5 mb-1 flex md:hidden justify-center"
            style={{ fontSize: 10 }}
          >
            <span>
              Deslize para o lado para visualizar todas as informações
            </span>{" "}
            <FaArrowsLeftRight />
          </small>
          <div className="rep-table-wrap">
            <table className="rep-table">
              <thead>
                <tr>
                  <th>Representante</th>
                  <th>Data cadastro</th>
                  <th>E-mail</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {!isLoadingListRepresentatives &&
                  listRepresentatives?.length > 0 &&
                  listRepresentatives.map((representative, index) => (
                    <tr key={index}>
                      <td className="rep-cell-name">{representative.name}</td>
                      <td>
                        {moment(representative.createdAt).format("DD/MM/yyyy")}
                      </td>
                      <td>{representative.email || "-"}</td>
                      <td>
                        <div className="rep-actions-inline flex w-full !justify-start">
                          <Tooltip
                            id="tooltip-edit"
                            content="Editar permissões"
                          />
                          <button
                            type="button"
                            className="rep-icon-btn"
                            data-tooltip-id="tooltip-edit"
                            onClick={() =>
                              handleEditPermissionQueries(representative)
                            }
                          >
                            <TbLockSearch fontSize="16" />
                          </button>

                          <Tooltip
                            id="tooltip-edit-representative"
                            content="Editar Representante"
                          />
                          <button
                            type="button"
                            className="rep-icon-btn"
                            data-tooltip-id="tooltip-edit-representative"
                            onClick={() =>
                              handleEditRepresentative(representative)
                            }
                          >
                            <FaRegEdit fontSize="16" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}

                {isLoadingListRepresentatives && (
                  <>
                    {[...Array(6)].map((_, idx) => (
                      <tr key={`loading-${idx}`}>
                        <td>
                          <div className="rep-skeleton rep-skeleton-lg" />
                        </td>
                        <td>
                          <div className="rep-skeleton" />
                        </td>
                        <td>
                          <div className="rep-skeleton rep-skeleton-lg" />
                        </td>
                        <td>
                          <div className="rep-skeleton rep-skeleton-sm" />
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
          </div>

          {totalCount > 0 && (
            <div className="mt-3 text-center text-sm">
              Foram encontrados {totalCount} registros no total
            </div>
          )}

          {totalPages > 1 && (
            <div className="flex overflow-x-auto justify-center mt-4">
              <Pagination
                layout="pagination"
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
                previousLabel=""
                nextLabel=""
                showIcons
              />
            </div>
          )}
        </>
      ) : (
        <EmptyTable icon="person_off">
          Nenhum representante cadastrado
        </EmptyTable>
      )}
      <Drawer
        title={`Permissões de consultas`}
        onClose={setIsDrawerPermissionQueries}
        isOpen={isDrawerPermissionQueries}
        className={"w-full md:w-4/6 lg:w-3/6"}
      >
        <UserQueriesForm
          user={selectedRepresentative}
          isOpen={isDrawerPermissionQueries}
          categories={categories}
          onClose={setIsDrawerPermissionQueries}
        />
      </Drawer>
      <Drawer
        title={`Editar representante`}
        onClose={setIsDrawerEditRepresentative}
        isOpen={isDrawerEditRepresentative}
        className={"w-full md:w-4/6 lg:w-3/6 xl:w-2/6"}
      >
        <UserForm
          user={selectedRepresentative}
          onClose={setIsDrawerEditRepresentative}
          fetchUsers={() =>
            queryClient.invalidateQueries(["listRepresentatives", currentPage])
          }
          type={"EDIT"}
        />
      </Drawer>
    </>
  );
};

export default AdminRepresentativesTable;
